const state = {
  ativo: false,
  atualizarPedidoCarrinhoCallback: null
}

const getters = {
  getAtivo({ativo}){
    return ativo;
  },
  atualizarPedidoCarrinhoCallback({atualizarPedidoCarrinhoCallback}) {
    return atualizarPedidoCarrinhoCallback;
  }
}

const mutations = {
  mudarVisibilidadeCarrinho(state, payload){
    state.ativo = payload;
  },
  atualizarPedidoCarrinhoCallback(state, payload){
    state.atualizarPedidoCarrinhoCallback = payload;
  },
}

const actions = {
  mudarVisibilidadeCarrinho(context, payload){
    context.commit("mudarVisibilidadeCarrinho", payload);
  },
  atualizarPedidoCarrinhoCallback(context, payload) {
    if (typeof payload !== 'function') {
      throw new Error(`${payload} deve ser a função que atualiza o carrinho de compra por departamento!`);
    }

    context.commit("atualizarPedidoCarrinhoCallback", payload);
  },
}

export default { namespaced: true, state, mutations, getters, actions }
